import { IonButton, IonIcon } from '@ionic/react';
import { cloudOfflineOutline, refreshOutline } from 'ionicons/icons';

import { PLATFORM_NAME } from '~/config';
import { useDocumentTitle } from '~/hooks/useDocumentTitle';

interface TenantUnavailableProps {
  onRetry: () => void;
}

/** O escritório não pôde ser consultado (sem rede, backend fora) e não há um lembrado para abrir. */
export function TenantUnavailable({ onRetry }: TenantUnavailableProps): JSX.Element {
  useDocumentTitle(PLATFORM_NAME);

  return (
    <main className="rx-container rx-screen px-6 py-12 flex flex-col items-center text-center">
      <span
        aria-hidden="true"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-negative-tint text-negative mb-5"
      >
        <IonIcon icon={cloudOfflineOutline} className="text-[24px]" />
      </span>
      <p className="font-mono text-[11px] uppercase tracking-[0.6px] mb-2 text-ink-muted">
        {PLATFORM_NAME}
      </p>
      <h1 className="text-[22px] font-medium tracking-tight text-ink mb-3">
        Não foi possível abrir o aplicativo.
      </h1>
      <p className="text-[14px] text-ink-muted max-w-[34ch] mb-6">
        Verifique a sua conexão com a internet e tente de novo.
      </p>
      <IonButton onClick={onRetry} className="rx-button">
        <IonIcon icon={refreshOutline} className="mr-2 text-[16px]" aria-hidden="true" />
        Tentar de novo
      </IonButton>
    </main>
  );
}
